import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import { PGET, PUT, DELETE } from "../../../api/adminApi"; // Added DELETE
import { CustomSvg } from "../../../utils/CustomSvg";
import { getDateTime } from "../../../utils/Dates";
import { Edit2, Trash2, Eye } from "react-feather";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal"; // For delete confirmation

export default function News() {
  const [items, setItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const getItems = React.useCallback(async () => {
    const data = await PGET("/services/admin/api/news-pageList", true, {
      page: currentPage,
      size: 10,
    });
    if (data && data.headers) {
      setPageCount(Math.ceil(data.headers["x-total-count"] / 10));
      setItems(data.data);
    }
  }, [currentPage]);

  const paginate = (data) => {
    setCurrentPage(data.selected);
  };

  const handleDelete = async () => {
    if (selectedId) {
      const response = await DELETE(`/services/admin/api/news/${selectedId}`);
      if (response && response.success) {
        toast.success("Успешно удалено");
        getItems();
      } else {
        //   toast.error("Ошибка при удалении"); // DELETE usually handles error toast in api.js?
      }
      setShowDeleteModal(false);
      setSelectedId(null);
    }
  };

  const togglePublish = async (id, currentStatus) => {
    const url = currentStatus
      ? `/services/admin/api/news/${id}/unpublish`
      : `/services/admin/api/news/${id}/publish`;

    const response = await PUT(url, {}, true);
    if (response && response.success) {
      toast.success(currentStatus ? "Снято с публикации" : "Опубликовано");
      getItems();
    }
  };

  useEffect(() => {
    getItems();
  }, [getItems]);

  return (
    <div
      className="br-5 card"
      style={{ background: "#eef1ff", marginTop: "-0.9rem", height: "100vh" }}
    >
      <div className="card-header border-0 pt-5">
        <h3 className="card-title align-items-start flex-column">
          <span
            className="card-label fw-bold fs-3 mb-1"
            style={{ marginLeft: -15 }}
          >
            Новости
          </span>
        </h3>
        <div
          className="card-toolbar"
          data-bs-toggle="tooltip"
          data-bs-placement="top"
          data-bs-trigger="hover"
          title="Click to add"
        >
          <Link
            to="/admin/news/create"
            className="btn btn-sm btn-light-primary"
          >
            <CustomSvg
              path="/icons/duotune/arrows/arr075.svg"
              className="svg-icon-3"
            />
            Добавить новый
          </Link>
        </div>
      </div>
      <div className="px-3 pb-4 pt-2">
        <div style={{ overflow: "auto", maxHeight: "75vh" }}>
          <table className="table bg-white table-rounded p-0 border gy-4 gs-7">
            <thead className="position-sticky top-0 rounded">
              <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                <th
                  style={{
                    width: "30px",
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopLeftRadius: "8px",
                  }}
                  className="text-white text-center"
                >
                  №
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Превью
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Главное фото
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Заголовок
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Текст
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Опубликовано
                </th>
                <th
                  className="text-start text-white"
                  style={{ backgroundColor: "#E7372C", fontWeight: "700" }}
                >
                  Время создания
                </th>
                <th
                  className="text-start text-white"
                  style={{
                    backgroundColor: "#E7372C",
                    fontWeight: "700",
                    borderTopRightRadius: "8px",
                  }}
                >
                  Действия
                </th>
              </tr>
            </thead>
            <tbody style={{ overflowX: "auto" }}>
              {items &&
                items.map((item, index) => {
                  return (
                    <tr key={item.id} className="borderBottom align-middle">
                      <td className="text-center">
                        {currentPage === 0
                          ? index + 1
                          : currentPage * 10 + index + 1}
                      </td>
                      <td className="text-start">
                        {item.thumbPhoto ? (
                          <img
                            src={
                              item.thumbPhoto.startsWith("http")
                                ? item.thumbPhoto
                                : "https://api-club.akfacomfort.uz" +
                                  item.thumbPhoto
                            }
                            alt="thumb"
                            style={{
                              height: 50,
                              width: 50,
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              height: 50,
                              width: 50,
                              backgroundColor: "#f3f6f9",
                              borderRadius: "4px",
                            }}
                          ></div>
                        )}
                      </td>
                      <td className="text-start">
                        {item.photo ? (
                          <img
                            src={
                              item.photo.startsWith("http")
                                ? item.photo
                                : "https://api-club.akfacomfort.uz" + item.photo
                            }
                            alt="main"
                            style={{
                              height: 50,
                              width: 50,
                              objectFit: "cover",
                              borderRadius: "4px",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              height: 50,
                              width: 50,
                              backgroundColor: "#f3f6f9",
                              borderRadius: "4px",
                            }}
                          ></div>
                        )}
                      </td>
                      <td className="text-start">{item.title}</td>
                      <td className="text-start">
                        {item.text && item.text.length > 50
                          ? item.text.substring(0, 50) + "..."
                          : item.text}
                      </td>
                      <td className="text-start">
                        {item.published ? (
                          <span
                            className="badge badge-success cursor-pointer"
                            onClick={() => togglePublish(item.id, true)}
                            title="Нажмите, чтобы снять с публикации"
                          >
                            Да
                          </span>
                        ) : (
                          <span
                            className="badge badge-danger cursor-pointer"
                            onClick={() => togglePublish(item.id, false)}
                            title="Нажмите, чтобы опубликовать"
                          >
                            Нет
                          </span>
                        )}
                      </td>
                      <td className="text-start">
                        {getDateTime(item.createdTime)}
                      </td>
                      <td className="text-end">
                        <div className="d-flex justify-content-end">
                          <Link
                            to={`/admin/news/view/${item.id}`}
                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                          >
                            <Eye className="svg-icon-3" />
                          </Link>
                          <Link
                            to={`/admin/news/update/${item.id}`}
                            className="btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
                          >
                            <Edit2 className="svg-icon-3" />
                          </Link>
                          <button
                            onClick={() => {
                              setSelectedId(item.id);
                              setShowDeleteModal(true);
                            }}
                            className="btn btn-icon btn-bg-light btn-active-color-danger btn-sm"
                          >
                            <Trash2 className="svg-icon-3" />
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        {pageCount > 1 && (
          <ReactPaginate
            forcePage={currentPage}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={pageCount}
            marginPagesDisplayed={1}
            pageRangeDisplayed={1}
            onPageChange={paginate}
            containerClassName={"pagination"}
            activeClassName={"bg-dark text-white"}
            pageClassName={"page-item box-shadow br-5"}
          />
        )}
      </div>

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Удаление</Modal.Title>
        </Modal.Header>
        <Modal.Body>Вы уверены, что хотите удалить эту новость?</Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={() => setShowDeleteModal(false)}
          >
            Отмена
          </button>
          <button className="btn btn-danger" onClick={handleDelete}>
            Удалить
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
